// src/js/animations/menu.js
export const initMenu = (lenis) => {
    const menuBtn = document.getElementById('menu-btn');
    const mobileMenu = document.getElementById('mobile-menu');
    const closeBtn = document.getElementById('close-menu');

    if (!menuBtn || !mobileMenu) return;

const toggleMenu = () => {
    const isOpen = !mobileMenu.classList.contains('translate-y-full');

    if (isOpen) {
        mobileMenu.classList.add('translate-y-full');
        menuBtn.classList.remove('active'); // La croix disparaît, retour au burger
        lenis.start();
    } else {
        mobileMenu.classList.remove('translate-y-full');
        menuBtn.classList.add('active'); // La croix se forme
        lenis.stop();
    }
};

    menuBtn.addEventListener('click', toggleMenu);
    if (closeBtn) closeBtn.addEventListener('click', toggleMenu);

    const links = mobileMenu.querySelectorAll('a');
    links.forEach(link => {
        link.addEventListener('click', () => {
            mobileMenu.classList.add('translate-y-full');
            menuBtn.classList.remove('active');
            lenis.start();
        });
    });
};